// extracted by mini-css-extract-plugin
module.exports = {"borderStyle":"style_borderStyle__uo9fq","paragraphColor":"style_paragraphColor__7Vqdg"};